import React from "react";
import clsx from "clsx";
import loadable from "@loadable/component";

import styles from "./ScrollToTopButton.styles";

const ReactSVGIcon = loadable(() => import("@micado-digital/react-svg-icon/ReactSVGIcon"));

const ScrollToTopButton = () => {
	const css = styles();

	const handleClick = () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth"
		});
	};

	return (
		<div
			className={clsx(css.button, "mco-view-component-header-scroll-top")}
			onClick={handleClick}
		>
			<ReactSVGIcon src="/img/icons/arrow-up.svg" size={24} />
		</div>
	);
};

export default ScrollToTopButton;
